import { createEvent, createStore } from 'effector'

export const openMapModal = createEvent()
export const closeMapModal = createEvent()

//@ts-expect-error
if (!window.__base_site__) {
	//@ts-expect-error
	window.__base_site__ = {}
}
//@ts-expect-error
window.__base_site__.openMapModal = openMapModal

export const $mapModal = createStore(false)
$mapModal.on(openMapModal, () => true).on(closeMapModal, () => false)
